"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconCloseEye = function IconCloseEye(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconCloseEye', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fill: "#999CA1",
    fillRule: "evenodd",
    d: "M.195.195c.26-.26.683-.26.943 0l14.667 14.667a.667.667 0 0 1-.943.943l-2.978-2.978A7.393 7.393 0 0 1 8 14c-2.253 0-4.226-1.088-5.903-2.877a13.661 13.661 0 0 1-1.5-1.928C.34 8.798.163 8.485.07 8.298a.667.667 0 0 1 .01-.613 12.967 12.967 0 0 1 2.966-3.697l-2.85-2.85a.667.667 0 0 1 0-.943zm3.796 4.74a11.633 11.633 0 0 0-2.563 3.067 12.342 12.342 0 0 0 1.641 2.209c1.448 1.544 3.1 2.456 4.92 2.456a6.047 6.047 0 0 0 2.925-.81L9.366 10.31A2.667 2.667 0 0 1 5.69 6.634zM8 2c2.253 0 4.226 1.088 5.903 2.877.576.615 1.077 1.271 1.5 1.928.257.397.433.71.527.897a.667.667 0 0 1-.009.612 13 13 0 0 1-1.518 2.242.667.667 0 1 1-1.02-.859c.446-.53.844-1.098 1.189-1.699a12.342 12.342 0 0 0-1.642-2.21c-1.447-1.543-3.1-2.455-4.932-2.455a5.413 5.413 0 0 0-1.246.143.667.667 0 1 1-.304-1.298c.51-.12 1.03-.18 1.552-.178zM6.685 7.629A1.333 1.333 0 0 0 8.37 9.315z"
  }));
};

var _default = IconCloseEye;
exports.default = _default;